var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavviLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    className: "savviLoading__gOuter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Savvi-Rectangle-Folded",
    className: "savviLoading__gInner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    className: "savviLoading__pathFirst",
    d: "M0.5,0.5L0.5,108.307L0.5,115.5L115.5,115.5L115.5,107.76L115.5,58L58,58L58,0.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    className: "savviLoading__pathSecond",
    d: "M65.5,3.5L112.5,50.5M115.5,58L115.5,69M58.5,0.5L44.5,0.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavviLoading);
export default __webpack_public_path__ + "static/media/savvi_loading.2f1545e5.svg";
export { ForwardRef as ReactComponent };